/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Form, Select, Skeleton } from 'antd';
import { selectSearcher } from 'utils/select';

const { Item } = Form;
const { Option } = Select;

const BadesulSelect = ({ input, loading, onUpdate, inputsFromDatabase, sizeMap }) => (
  <Col {...sizeMap[input.size]}>
    <Item
      name={input.value}
      rules={
        input.notRequired
          ? []
          : [
              {
                required: true,
                message: `Por favor preencha o campo ${input.name.toLowerCase()}.`,
              },
            ]
      }
      label={input.name}
    >
      {loading ? (
        <Skeleton.Button shape="square" active className="gyramais-input-skeleton" size="large" />
      ) : (
        <Select
          className="gyramais-input"
          placeholder={input.name}
          loading={loading}
          disabled={loading}
          onChange={() => {
            onUpdate((value) => !value);
          }}
          showSearch
          filterOption={selectSearcher}
        >
          {input.options
            ? input.options.map((option) => {
                const optionName = option.name || option;
                const optionValue = option.value || option;
                return (
                  <Option value={optionValue} label={optionName}>
                    {optionName}
                  </Option>
                );
              })
            : inputsFromDatabase[input.optionsFromDatabase].map((option) => (
                <Option value={option.id} label={option.name}>
                  {option.name}
                </Option>
              ))}
        </Select>
      )}
    </Item>
  </Col>
);

export default BadesulSelect;
